import React from 'react';
import { useState } from 'react';
import PageTitle from '../../common/components/PageTitle';
import { selectUser } from '../../common/auth/UserSlice';
import { useSelector } from 'react-redux';
import { Typography } from '@mui/material';
import { Stack, Paper, Divider, Button, Grid } from '@mui/material';
import { styled } from '@mui/system';
import { AvatarDisplay } from '../../common/components/AvatarDisplay';
import UpdateUserForm from './UpdateUserForm';
import ConfirmEmailForm from './ConfirmEmailForm';
import ChangePasswordForm from './ChangePasswordForm';
import EditIcon from '@mui/icons-material/Edit';
import LockResetIcon from '@mui/icons-material/LockReset';

const Item = styled(Paper)(({ theme }) => ({
  boxShadow: 'none',
  borderRadius: 0,
  margin: theme.spacing(0.5),
}));

const LeftItem = styled(Paper)(({ theme }) => ({
  boxShadow: 'none',
  borderRadius: 0,
  margin: theme.spacing(0.5),
  width: '98%',
  textAlign: 'left',
}));

export function Profile() {
  const userInfo = useSelector(selectUser);
  const [editingProfileDetails, setEditingProfileDetails] = useState(false);
  const [changingPassword, setChangingPassword] = useState(false);

  return (
    <>
      <PageTitle title='Profile' />
      <Grid
        container
        alignItems='flex-start'
        justifyContent='center'
        direction='row'
        style={{ width: '100%' }}
      >
        <Grid item xs={12} md={6}>
          <AvatarDisplay />
        </Grid>
        <Grid item xs={12} md={6}>
          {!userInfo.emailVerified ? (
            <Stack alignItems='center' justifyContent='center'>
              <Item>
                <Typography variant='h5'>Confirm Email Address</Typography>
              </Item>
              <Item sx={{ width: '50%' }}>
                <Divider />
              </Item>
              <Item>
                <ConfirmEmailForm />
              </Item>
            </Stack>
          ) : editingProfileDetails ? (
            <Stack alignItems='center' justifyContent='center'>
              <Item>
                <Typography variant='h5'>Edit Profile Details</Typography>
              </Item>
              <Item sx={{ width: '50%' }}>
                <Divider />
              </Item>
              <Item>
                <UpdateUserForm
                  callback={() => setEditingProfileDetails(false)}
                />
              </Item>
            </Stack>
          ) : changingPassword ? (
            <Stack alignItems='center' justifyContent='center'>
              <Item>
                <Typography variant='h5'>Change Password</Typography>
              </Item>
              <Item sx={{ width: '50%' }}>
                <Divider />
              </Item>
              <Item>
                <ChangePasswordForm
                  callback={() => setChangingPassword(false)}
                />
              </Item>
            </Stack>
          ) : (
            <>
              <Stack alignItems='center' justifyContent='center'>
                <Item>
                  <Typography variant='h5'>Current Profile Details</Typography>
                </Item>
                <Item sx={{ width: '50%' }}>
                  <Divider />
                </Item>
                <LeftItem>
                  <Typography>
                    <b>Full Name</b>
                    <br /> {userInfo.firstName} {userInfo.lastName}
                  </Typography>
                </LeftItem>
                <LeftItem>
                  <Typography>
                    <b>Email</b>
                    <br /> {userInfo.email}
                  </Typography>
                </LeftItem>
                <Item>
                  <Button
                    variant='contained'
                    color='secondary'
                    onClick={() => setEditingProfileDetails(true)}
                  >
                    <EditIcon style={{ marginRight: '5' }} />
                    Edit Profile Details
                  </Button>
                </Item>
                <Item sx={{ marginTop: 4 }}>
                  <Typography variant='h5'>Password</Typography>
                </Item>
                <Item sx={{ width: '50%' }}>
                  <Divider />
                </Item>
                <Item>
                  <Button
                    variant='contained'
                    color='tertiary'
                    onClick={() => setChangingPassword(true)}
                  >
                    <LockResetIcon style={{ marginRight: '5' }} />
                    Change Password
                  </Button>
                </Item>
              </Stack>
            </>
          )}
        </Grid>
      </Grid>
    </>
  );
}
